<template>
    <el-table @selection-change="handleSelectionChange" :data="tableData" empty-text="暂无数据" stripe v-loading="loading"  border :size="size" :ref="refv">
        <slot>
            <el-table-column label="课次" type="index" width="50" :resizable="RESIZABLE"/>
            <el-table-column label="上课日期" prop="lession_date" :resizable="RESIZABLE"/>
            <el-table-column label="上课方式" prop="class_way" width="80" :resizable="RESIZABLE"/>
            <el-table-column label="签到状态" prop="status" width="80" :resizable="RESIZABLE"/>
            <el-table-column label="签到人数" prop="sign_number" width="80" :resizable="RESIZABLE"/>
            <el-table-column label="旷课人数" prop="kk_number" width="80" :resizable="RESIZABLE"/>
            <el-table-column label="任课老师" prop="teacher_name" width="90" :resizable="RESIZABLE"/>
        </slot>
    </el-table>
</template>

<script>
    import Vue, { Component } from 'C/BaseVue'
    import mixin, { tableConstant } from 'M/mixin'

    @Component({
        components: {},
        props: {
            tableOption: {
                type: Object,
                required: false,
                default: ()=>{}
            },
            loading: {
                type: Boolean,
                required: false,
                default: ()=>{
                    return false
                }
            },
            size: {
                type: String,
                required: false,
                default: ()=>{
                    return 'small'
                }
            },
            tableData: {
                type: [Array],
                required: true,
                default: ()=>{
                    return []
                }
            },
            refv: {
                type: String,
                required: false,
                default: ()=>{
                    return 'table'
                }
            }        
        },
        watch: {},
        mixins: [mixin, tableConstant]
    })

    export default class BossTableTabs extends Vue {
        mounted(){}
    }

</script>
<style lang="scss" type="text/css" scoped></style>


// WEBPACK FOOTER //
// src/components/BossTableTabs.vue